module.exports = __webpack_public_path__ + "static/pic03-0fa7418fafc59d78922c5898422c8564.png";